// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.photos.RentalManagerUserPropertyPhotoV2WebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPropertyPhotoV2WebApiHandler_caption,
  RentalManagerUserPropertyPhotoV2WebApiHandler_delete,
  RentalManagerUserPropertyPhotoV2WebApiHandler_rank,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  UserPropertyPhotoCaptionV2RequestDto,
  UserPropertyPhotoDeleteV2RequestDto,
  UserPropertyPhotoRankV2RequestDto,
} from '@zg-rentals/ts-rental-manager-api-client';

export interface RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Args {
  postData: UserPropertyPhotoCaptionV2RequestDto;
}

export type RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Args
>;

/**
 * Update a photo caption
 */
export const useRentalManagerUserPropertyPhotoV2WebApiHandler_caption = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoV2WebApiHandler_caption_Args) =>
      RentalManagerUserPropertyPhotoV2WebApiHandler_caption(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Args {
  postData: UserPropertyPhotoDeleteV2RequestDto;
}

export type RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Args
>;

/**
 * Delete a property photo
 */
export const useRentalManagerUserPropertyPhotoV2WebApiHandler_delete = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoV2WebApiHandler_delete_Args) =>
      RentalManagerUserPropertyPhotoV2WebApiHandler_delete(args.postData, httpClient),
  });
};

export interface RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Args {
  postData: UserPropertyPhotoRankV2RequestDto;
}

export type RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Args
>;

/**
 * Update the rank of photos
 */
export const useRentalManagerUserPropertyPhotoV2WebApiHandler_rank = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyPhotoV2WebApiHandler_rank_Args) =>
      RentalManagerUserPropertyPhotoV2WebApiHandler_rank(args.postData, httpClient),
  });
};
